import request from '@/utils/request'

const publisherURL = {
  Create: '/article-author/list',
  List: '/article-author/list',
  Detail: '/article-author/detail',
  Update: '/article-author/update',
  Delete: '/article-author/delete'
}

// 创建发布者
export function createPublisher (data) {
  return request({
    url: publisherURL.Create,
    method: 'post',
    data
  })
}

// 发布者列表
export function listPublisher (data) {
  return request({
    url: publisherURL.List,
    method: 'post',
    data
  })
}

// 发布者详情
export function detailPublisher (data) {
  return request({
    url: publisherURL.Detail,
    method: 'post',
    data
  })
}

// 更新发布者
export function updataPublisher (data) {
  return request({
    url: publisherURL.Update,
    method: 'post',
    data
  })
}

// 删除发布者
export function deletePublisher (data) {
  return request({
    url: publisherURL.Delete,
    method: 'post',
    data
  })
}

export default {
  createPublisher,
  listPublisher,
  detailPublisher,
  updataPublisher,
  deletePublisher
}
